import * as React from 'react';
import styled from 'styled-components';

import { RESOLUTIONS } from 'src/constants/general/settings';
import { windowSize } from 'src/stores/windowSize';

import { Utility } from '../Typography';
import { BaseButtonProps } from './types';

type BaseProps = {
  fullWidth?: boolean;
};

const PrimaryBase = styled.button<BaseProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.fullWidth ? '100%' : '')};

  border-radius: 1px;
  border: none;
  background: ${(props) => props.theme.main.colors.auroraLemon};
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.main.colors.auroraLemon66};
  }

  &:disabled {
    background: ${(props) => props.theme.main.colors.clay4};
    pointer-events: none;

    span {
      color: ${(props) => props.theme.main.colors.white};
    }
  }
`;

const PrimarySmall = styled(PrimaryBase)`
  padding: 6px 24px;

  @media (min-width: ${RESOLUTIONS.medium}px) {
    padding: 11px 40px;
  }
`;

const PrimaryMedium = styled(PrimaryBase)`
  padding: 11px 40px;

  @media (min-width: ${RESOLUTIONS.medium}px) {
    padding: 16px 48px;
  }
`;

const PrimaryLarge = styled(PrimaryBase)`
  padding: 16px 48px;

  @media (min-width: ${RESOLUTIONS.medium}px) {
    padding: 26px 48px;
  }
`;

const ComponentTypes = {
  large: PrimaryLarge,
  medium: PrimaryMedium,
  small: PrimarySmall,
};

const ComponentMobileSizes = {
  large: 'u1',
  medium: 'u2',
  small: 'u3',
};

export const PrimaryButton: React.FC<BaseButtonProps> = (props) => {
  const { size = 'large', ...rest } = props;
  const Component = ComponentTypes[size];
  let utilityVariant: 'u1' | 'u2' | 'u3' | 'u4' = ComponentMobileSizes[size] as 'u1' | 'u2' | 'u3';

  if (windowSize.isGreaterThan('medium')) {
    utilityVariant = size === 'small' ? 'u4' : 'u2';
  }

  return (
    <Component {...rest} {...testAnchors.useButton(props.ATN)}>
      <Utility variant={utilityVariant} weight='bold'>
        {props.children}
      </Utility>
    </Component>
  );
};
